import degree from './degree'
import homepage from './homepage'

const studentspace = {
  path: 'studentspace',
  component: resolve => require(['../../../components/pages/studentspace'], resolve),
  redirect: 'studentspace/homepage',
  children: [
    ...degree,
    homepage
  ]
}

export default studentspace



// WEBPACK FOOTER //
// ./src/router/pages/studentspace/index.js